import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m12.54 8.433-.631 2.319s-.705-.315-1.541-.264c-1.226.077-1.239.834-1.226 1.025.066 1.037 2.849 1.263 3.005 3.692.123 1.911-1.034 3.219-2.7 3.322-2 .124-3.102-1.033-3.102-1.033l.424-1.768s1.109.82 1.996.765a.774.774 0 0 0 .765-.825c-.087-1.353-2.352-1.273-2.496-3.496-.12-1.87 1.133-3.766 3.897-3.936 1.065-.068 1.61.199 1.61.199Z"
});
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "3",
  x2: "20.999",
  y1: "15.939",
  y2: "15.939",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F54752"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#FF8C00"
})));
var ShopifyIcon = function ShopifyIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#788590' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M18.765 5.851c-.014-.1-.104-.157-.179-.163a163.18 163.18 0 0 0-1.526-.028s-1.214-1.156-1.334-1.274c-.12-.117-.355-.082-.446-.055l-.61.185a4.152 4.152 0 0 0-.292-.703c-.432-.81-1.065-1.237-1.83-1.238h-.003c-.053 0-.106.005-.16.01a2.326 2.326 0 0 0-.068-.08c-.333-.349-.76-.52-1.273-.504-.988.028-1.972.727-2.77 1.97-.56.875-.988 1.973-1.11 2.824l-1.945.59c-.572.177-.59.195-.665.724C4.498 8.509 3 19.87 3 19.87L15.557 22l5.442-1.327s-2.22-14.72-2.234-14.822Zm-4.723-1.144-.975.296c-.007-.49-.067-1.173-.3-1.763.75.14 1.119.971 1.275 1.467Zm-1.632.495-2.096.637c.202-.76.586-1.518 1.059-2.015.175-.185.42-.39.711-.508.274.56.333 1.351.326 1.886Zm-1.346-2.556c.232-.005.427.045.594.152a2.854 2.854 0 0 0-.767.586c-.628.66-1.109 1.685-1.3 2.674l-1.722.523c.34-1.557 1.67-3.892 3.195-3.935Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M18.587 5.688c-.075-.006-1.526-.027-1.526-.027s-1.215-1.157-1.335-1.274a.3.3 0 0 0-.168-.076v17.688L21 20.673 18.765 5.851c-.014-.1-.104-.157-.178-.163Z"
  }), _ref2, _ref3);
};
export default ShopifyIcon;